import type { ReactElement } from 'react'
import styled from 'styled-components'
import { COLORS } from '@monthio/react-components'
import { BodyL, H1, H2 } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'
import { ErrorCircle } from '@monthio/icons'

const ErrorIcon = styled(ErrorCircle)`
	width: 40px;
`

const PensionListCard = styled.div`
	text-align: left;
	padding: 16px;
	margin: 12px 0;
	background-color: ${COLORS.BACKGROUND_LIGHT};
`

const StyledH2Flow = styled(H2)`
	margin: 0 0 4px 0;

	${(props) => props.theme.breakpoints.up('sm')} {
		margin: 0 0 8px 0;
	}
`

const Wrapper = styled.div`
	margin: 5px 10px;
`

export const PensionError = (): ReactElement => {
	const { t } = useTranslation()
	return (
		<Wrapper>
			<div>
				<ErrorIcon />
			</div>
			<H1>{t('pensionPage-error-title')}</H1>
			<BodyL>{t('pensionPage-error-description')}</BodyL>
			<PensionListCard>
				<StyledH2Flow>{t('pensionPage-error-open-popup-text')}</StyledH2Flow>
				<BodyL>{t('pensionPage-error-open-popup-solution')}</BodyL>
			</PensionListCard>
			<PensionListCard>
				<StyledH2Flow>
					{t('pensionPage-error-technical-problem-text')}
				</StyledH2Flow>
				<BodyL>{t('pensionPage-error-technical-problem-solution')}</BodyL>
			</PensionListCard>
		</Wrapper>
	)
}
